
async function getAuthorizationFromMSAL(clientId, apiScopes) {
  const msalConfig = {
    auth: {
      clientId: clientId,
      authority: "https://login.microsoftonline.com/6e93a626-8aca-4dc1-9191-ce291b4b75a1",
      redirectUri: window.location.origin
    },
    system: {
      allowRedirectInIframe: true,
      windowHashTimeout: 30000
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: true
    }
  };

  const msalInstance = new msal.PublicClientApplication(msalConfig);
  const accounts = msalInstance.getAllAccounts();
  let authData = { idToken: '', graphToken: '' , userId: '' };
  let savedScrollY = window.scrollY;

  if (accounts.length > 0) {
    console.log("Using existing account:");
    msalInstance.setActiveAccount(accounts[0]);

    try {
      const tokenResponse = await msalInstance.acquireTokenSilent({  scopes: apiScopes, account: accounts[0], forceRefresh: true });

      if (tokenResponse?.accessToken) {
        authData.idToken = "Bearer " + tokenResponse.accessToken;
      } else {
        throw new Error("Token response is empty or invalid.");
      }
    } catch (error) {
      console.warn("Silent token retrieval failed:", error);
      if (error.name === "InteractionRequiredAuthError") {
        console.log("Fallback to loginPopup...");
        const popupResponse = await msalInstance.loginPopup();

        if (popupResponse?.accessToken) {
          authData.idToken = "Bearer " + popupResponse.accessToken;
          msalInstance.setActiveAccount(popupResponse.account);
        } else {
          throw new Error("Popup response is empty or invalid.");
        }
      } else {
        throw new Error(`Authentication failed: ${error.message}`);
      }
    }
  } else {
    console.warn("No existing accounts, triggering login...");
    const popupResponse = await msalInstance.loginPopup();

    if (popupResponse?.accessToken) {
      authData.idToken = "Bearer " + popupResponse.accessToken;
      msalInstance.setActiveAccount(popupResponse.account);
    } else {
      throw new Error("Popup response is empty or invalid.");
    }
  }

  window.scrollBy(0, savedScrollY);
  return authData; // ✅ Returns an object { idToken, userId }
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function disableEditLink(obj) {
  var element = obj.href; //get the editLink from form
  if (null !== element) {
    element.onclick = dummyfunction;
    element.disabled = true;
  }
}

function dummyfunction() {
  return false;
}

function showDetails(id){
  document.getElementById(id).style.display="block";
}

function hideDetails(element){
  element.style.display="none";
}

function showLoading() {
  document.body.style.cursor = "wait";
  disableHref();
  disableTree();
  saveScrollLocation();
}

function showPreLoadedPopup(element) {

  setupBlockingLayer();
  alignPopupInCenter(element.id);
  element.style.visibility = 'visible';
  return false;
}

function disableTree() {
  var tree = document.getElementById("treePanel");
  tree.disabled = true;
  tree.style.cursor = "wait";
}

function disableHref(){
  var input = document.getElementsByTagName("a");
  var count = input.length;
  for(var i = 0; i < count; i++){
    // just to give the mousepointer the wait symbol instead of the hand
    input[i].style.cursor = "wait";
    // Does not disable the link it just gives it a grey color, but works with buttons
    input[i].disabled = true;
    //OBS this works but also stops the request and the next page does not get loaded, just
    //hangs in the first page
    input[i].setAttribute("onclick", dummyfunction);
  }
}


// Het juiste form_id bepalen adhv de index van de link (voor de Chartaal schermen)
// De form-Id's worden dynamische in een <tr:form> binnen een <tr:iterator> bepaald
// Voor de diverse pop-ups moet het juiste form_id bepaald worden
function getFormId(index, aantalKolommen, skip) {

  // Functie wordt vanuit verschillende Chartaal schermen aangeroepen met
  // een verschillend aantal parameters

  // Bepaal de juiste formId van het kenmerkenPopupForm
  if (getFormId.arguments.length > 1 && index > aantalKolommen) {
    // Als er meer dan het maximaal aantal rekeningen zijn, de juiste form
    // bepalen
    index = index % aantalKolommen;
  }
  // Als het de laatste van het rijtje is
  if (getFormId.arguments.length > 1 && index === 0) {
    index = aantalKolommen;
  }
  // als we in de popup zitten, de forms van het aantal maanden(6) overslaan
  if (getFormId.arguments.length === 3) {
    index = index + skip;
  }

  var form = document.forms[index];
  return form.id;
}

function saveScrollLocation() {
  var scrollLocation = document.getElementById("scrollLocation");
  scrollLocation.setAttribute('value',document.documentElement.scrollTop);
}

function restoreScrollLocation() {
  var scrollLocation = document.getElementById("scrollLocation");
  window.scrollTo(0, scrollLocation.value);
}

function getPosition(element) {
  var p = {x: element.offsetLeft || 0, y:element.offsetTop || 0};
  while ( (element = element.offsetParent) !== null) {
    p.x += element.offsetLeft;
    p.y += element.offsetTop;
  }
  return p;
}

function hidePopup(element) {
  element.style.visibility = 'hidden';
  var blockLayer = document.getElementById('blockLayer');
  if (blockLayer !== null) {
    blockLayer.style.visibility = 'hidden';
  }
}

function alignPopupInCenter(popupId) {
  var popup = document.getElementById(popupId);
  if (popup === null) {
    return false;
  }

  var top = document.getElementsByClassName('details-view-container').item(0).getBoundingClientRect().top;
  if (top <= 0) {
    top = -top;
  } else if (top > 100) {
    top = 0;
  }

  popup.style.top = 100 + top + 'px';
  popup.style.left = ((document.documentElement.clientWidth / 2) - (popup.clientWidth / 2)) + 'px';

}

function alignPopupAtCursor(event, popupId) {
  var popup = document.getElementById(popupId);
  if (popup === null) {
    return false;
  }
  if (!cursor) {
    alignPopupInCenter(popupId);
  } else {
    popup.style.left = cursor.x + "px";
    popup.style.top  = cursor.y + "px";
  }
}

function isAsyncNotAvail(){
  var xmlhttp = getXmlHttpRequest();
  if ( xmlhttp === null ){
    return true;
  }
  return false;
}

function getXmlHttpRequest() {
  var request = null;
  if ( window.XMLHttpRequest ) {
    request = new XMLHttpRequest();
  } else if (window.ActiveXObject) {
    request = new ActiveXObject('Microsoft.XMLHTTP');
  }
  return 	request;
}

function loadMouseoverAsync(event, url, popupId, formId, startColumn) {

  if( isAsyncNotAvail() ){
    return true;
  }else {
    var request = getXmlHttpRequest();
    url += '?gen=' + new Date().getTime();
    if (loadMouseoverAsync.arguments.length === 5) {
      url += '&firstColumn=' + startColumn;
    }

    try {
      request.open('POST', url, true);
    } catch(e) {
      return true;
    }


    request.onreadystatechange = function() {

      if (request.readyState === 4
        && (request.status === 200 || request.status === 403)
        && request.responseText) {
        clearTimeout(requestTimeout);

        popup = document.getElementById(popupId);
        if (request.status === 403) {
          popup.style.backgroundColor = "white";
          popup.innerHTML = "Sessie is verlopen, kies opnieuw een klant";
        } else {
          // Response comes from CIV server, so no cross site
          // scripting threat.
          popup.innerHTML =  returnResponseText(request);
        }
        var error = document.getElementById('errorGrid');
        if (error !== null) {
          var rootElement = document.getElementById('treePanel').parentNode;
          rootElement.removeChild(document
            .getElementById('treePanel'));
          rootElement.removeChild(document
            .getElementById('loadingDiv'));
          rootElement.appendChild(error);
        } else {
          alignPopupAtCursor(event, popupId);
          popup.style.visibility = 'visible';
          $('#' + popupId).show();
        }
      } else {
        return true;
      }

    };

    var requestTimeout=setTimeout(function(){
      ajaxTimeout(request);
    }, 5000);
    var params = getAllHiddenFields(formId,popupId);
    request.setRequestHeader("Content-type", "application/x-www-form-urlencoded;charset=UTF-8");
    request.setRequestHeader("Content-length", params.length);
    request.setRequestHeader("Connection", "close");

    request.send(params);
  }

  return false;
}


//  function openPopup(event, url, popupId, formId) {
//
//     var baseUrl = civViewBaseURL + "productoverview/";
//     var endUrl = url.split("/", 3)[2];
//     var newUrl = baseUrl + endUrl;
// 	if (isAsyncNotAvail()) {
// 		return true;
// 	} else {
// 		var request = getXmlHttpRequest();
//
// 		try {
// 			request.open('POST', newUrl, true);
// 		} catch (e) {
// 			return true;
// 		}
//
// 		request.onreadystatechange = function() {
// 			if (request.readyState === 4
// 					&& (request.status === 200 || request.status === 403)
// 					&& request.responseText) {
//
// 				clearTimeout(requestTimeout);
// 				let popup = document.getElementById(popupId);
// 				if (request.status === 403) {
// 					popup.style.backgroundColor = "white";
// 					popup.innerHTML = "Sessie is verlopen, kies opnieuw een klant";
// 				} else {
// 					// Response comes from CIV server, so no cross site
// 					// scripting threat.
// 					popup.innerHTML = request.responseText;
// 					//Trigger the popupInserted event
// 					if($('#' + popupId).trigger){
// 						$('#' + popupId).trigger('popupInsertedEvent');
// 					}
// 				}
// 				var error = document.getElementById('errorGrid');
// 				if (error !== null) {
// 					var rootElement = document.getElementById('treePanel').parentNode;
//
// 					rootElement.removeChild(document
// 							.getElementById('treePanel'));
// 					rootElement.removeChild(document
// 							.getElementById('loadingDiv'));
//
// 					rootElement.appendChild(error);
// 				} else {
// 					alignPopupInCenter(popupId);
// 					popup.style.visibility = 'visible';
// 					$('#' + popupId).show();
// 					//Trigger the popupInserted event
// 					if($('#' + popupId).trigger){
// 						$('#' + popupId).trigger('popupShowEvent');
// 					}
// 				}
// 			} else {
// 				return true;
// 			}
//
// 		};
//
// 		var requestTimeout = setTimeout(function() {
// 			ajaxTimeout(request);
// 		}, 5000);
// 		var params = getAllHiddenPopUpFields(formId, popupId);
//     request.setRequestHeader("Content-type", "application/x-www-form-urlencoded;charset=UTF-8");
//     request.setRequestHeader("Content-length", params.length);
//     request.setRequestHeader("Connection", "close");
// 		request.send(params);
// 	}
//
// 	return false;
// }

function loadPopupAsync(url, popupId, formId, startColumn) {
  if( isAsyncNotAvail() ) {
    return true;
  } else {

    var request = getXmlHttpRequest();
    url += '?gen=' + new Date().getTime();

    // Als we in de bestellenMaandOvz of stortenMaandOvz popup zitten,
    // komt er een extra parameter mee en hoeven we de loadingDiv niet te laten zien
    var inPopup = false;
    if (loadPopupAsync.arguments.length === 4) {
      inPopup = true;
      url += '&firstColumn=' + startColumn;
    }

    try {
      request.open('POST', url, true);
    } catch(e) {
      return true;
    }

    if (!inPopup) {
      var loadingDiv = document.getElementById('loadingDiv');
    }

    request.onreadystatechange = function() {
      if (!inPopup) {
        if(request.readyState === 1 || request.readyState === 2 || request.readyState === 3){
          alignPopupInCenter('loadingDiv');
          loadingDiv.style.visibility = 'visible';
        }
      }
      if (request.readyState === 4) {
        if ((request.status === 200 || request.status === 403) && request.responseText) {
          clearTimeout(requestTimeout);
          setupBlockingLayer();
          popup = document.getElementById(popupId);
          if (request.status === 403) {
            popup.style.backgroundColor = "white";
            popup.innerHTML = "Sessie is verlopen, kies opnieuw een klant";
          } else {
            // Response comes from CIV server, so no cross site scripting threat.
            popup.innerHTML = returnResponseText(request);
          }
          var error = document.getElementById('errorGrid');
          if(error !== null) {
            var rootElement = document.getElementById('treePanel').parentNode;

            rootElement.removeChild(document.getElementById('treePanel'));
            rootElement.removeChild(document.getElementById('blockLayer'));
            rootElement.removeChild(document.getElementById('loadingDiv'));

            rootElement.appendChild(error);
          } else {
            alignPopupInCenter(popupId);
            if (!inPopup) {
              loadingDiv.style.visibility = 'hidden';
            }
            popup.style.visibility = 'visible';
          }
        } else  {
          return true;
        }
      }
    };

    var requestTimeout=setTimeout(function(){
      ajaxTimeout(request);
    }, 5000);
    var params = getAllHiddenFields(formId,popupId);
    request.setRequestHeader("Content-type", "application/x-www-form-urlencoded;charset=UTF-8");
    request.setRequestHeader("Content-length", params.length);
    request.setRequestHeader("Connection", "close");

    request.send(params);
  }

  return false;
}




function ajaxTimeout(request){
  request.abort();
  document.getElementById('loadingDiv').style.visibility = 'hidden';
  document.getElementById('blockLayer').style.visibility = 'hidden';
  alert("Er is een onbekende fout opgetreden.");
}

function getAllHiddenFields(formId) {
  var getstr = "";
  var obj = document.getElementById(formId);
  for (i = 0; i < obj.childNodes.length; i++) {
    if (obj.childNodes[i].tagName === 'INPUT'
      && obj.childNodes[i].type === 'hidden') {

      var b = obj.childNodes[i].id;
      var temp = b.split(':');
      var name = '';
      if (temp.length === 1){
        name = temp[0];
      } else if (temp.length === 2){
        name = temp[1];
      } else {
        name = temp[2];
      }

      getstr += name + '=' + encodeURIComponent(obj.childNodes[i].value)
        + '&';

    }
  }

  return getstr;
}

function getAllHiddenPopUpFields(formId) {
  var parametersToken = getParameterByName('parametersToken');
  var requestBody = "";
  var obj = document.getElementById(formId);
  for (i = 0; i < obj.childNodes.length; i++) {
    if (obj.childNodes[i].tagName === 'INPUT'
      && obj.childNodes[i].type === 'hidden') {
      var b = obj.childNodes[i].id;
      var temp = b.split(':');
      var name;
      if (temp.length === 1){
        name = temp[0];
      } else if (temp.length === 2){
        name = temp[1];
      } else {
        name = temp[2];
      }
      if (name === 'ArrangementNumber'){
        var arrangementNumber = obj.childNodes[i].value;
      }
      if (name === 'AdministrationTypeCode'){
        var administrationTypeCode = obj.childNodes[i].value;
      }
      if (name === 'Popup'){
        var popupId = obj.childNodes[i].value;
      }
      if (name === 'BankCode'){
        var bankCode = obj.childNodes[i].value;
      }
      if (name === 'TableNumber'){
        var tableNumber = obj.childNodes[i].value;
      }
      if (name === 'MinRate'){
        var minRate = obj.childNodes[i].value;
      }
      if (name === 'MaxRate'){
        var maxRate = obj.childNodes[i].value;
      }
      if (name === 'FlatRate'){
        var flatRate = obj.childNodes[i].value;
      }
      if (name=== 'Type'){
        var type = obj.childNodes[i].value;
      }
      if (name === 'CreditRenteAfspraak'){
        var creditRenteAfspraak = obj.childNodes[i].value;
      }
      if (name === 'ProductCode'){
        var productCode = obj.childNodes[i].value;
      }
      if (name === 'Month'){
        var month = obj.childNodes[i].value;
      }
      requestBody = {
        arrangementNumber,
        administrationCode: administrationTypeCode,
        popupId,
        bankCode,
        tableNumber,
        minRate,
        maxRate,
        flatRate,
        type,
        creditRenteAfspraak,
        productCode,
        month,
        parametersToken,
      };
    }
  }

  return JSON.stringify(requestBody);
}

function setupBlockingLayer() {
  var height = document.documentElement.scrollHeight;
  if(height < document.documentElement.clientHeight){
    height = document.documentElement.clientHeight;
  }

  var width = document.documentElement.scrollWidth;
  if(width < document.documentElement.clientWidth){
    width = document.documentElement.clientWidth;
  }

  var blockLayer = document.getElementById('blockLayer');
  blockLayer.style.cssText = 'height:' + height + 'px;width:' + width + 'px;';
}

function checkAddProduct() {
  var error = "";
  if ("" === document.getElementById('adminCode').value) {
    error += 'adminCode mag niet leeg zijn';
  }
  if ("" === document.getElementById('prodCode').value) {
    if (error !== "") {
      error += "\r\n";
    }
    error += 'prodCode mag niet leeg zijn';
  }
  if ("" === document.getElementById('pdGroup').value) {
    if (error !== "") {
      error += "\r\n";
    }
    error += 'pdGroup mag niet leeg zijn';
  }
  if (error !== "") {
    alert(error);
    return false;
  }
  return true;
}

function MinibtnHover(obj)
{
  if (obj.className !== 'miniBtnUICFocus')
  {
    obj.className='miniBtnUICHover';
    obj.parentNode.className='miniBtnUICTopHover';
  }
}
function MinibtnOut(obj)
{
  if (obj.className !== 'miniBtnUICFocus')
  {
    obj.className='miniBtnUIC';
    obj.parentNode.className='miniBtnUICTop';
  }

}

function BtnHover(obj)
{
  if (obj.className !== 'BtnFocus')
  {
    obj.className='submitBtnHover';
  }
}
function BtnOut(obj)
{
  if (obj.className !== 'BtnFocus')
  {
    obj.className='submitBtn';
  }
}




function clickAuthorisationRadio(id){
  if(id === 'wijzigen'){
    klikWijzigen();
  }
  if(id === 'opheffen'){
    klikOpheffen();
  }
  if(id === 'productservices'){
    klikProductServices();
  }
  if(id === 'transacties'){
    //nu geen methode voor
  }
  if(id === 'inzien'){
    klikInzien();
  }
}

/**
 * Utility methods for scrolling header and data columns
 * Need for setting following variables in you code.
 *
 * 	 var cnum = ${model.dynamictable.numberOfColumnsPopup};
 *   var columnOffsetHeader = 3;
 *   var columnOffsetData = 3;
 *   var showColumnsHeader = 6;
 *   var showColumnsData = 6;
 *   var scrollStepHeader = 6;
 *   var scrollStepData = 6;
 *   var startIndexHeader = 0;
 *   var startIndexData = 0;
 *   var endIndexHeader = columnOffsetHeader + cnum;
 *   var endIndexData = columnOffsetData + cnum;
 *
 *
 */
function nextColumns(){
  for(i=0;i<scrollStepHeader;i++){
    startIndexHeader = startIndexHeader + 1;
  }
  for(i=0;i<scrollStepData;i++){
    startIndexData = startIndexData + 1;
  }
  $('input[id="previousColumns"]').removeAttr('disabled');
  scrollH();
};

function previousColumns(){
  // set the startIndex
  for(i=scrollStepHeader;i>0;i--){
    startIndexHeader = startIndexHeader - 1;
    if((startIndexHeader)===0){
      break;
    }
  }
  for(i=scrollStepData;i>0;i--){
    startIndexData = startIndexData - 1;
    if((startIndexData)===0){
      break;
    }
  }
  $('input[id="nextColumns"]').removeAttr('disabled');
  scrollH();

};

function scrollH(){
  $('input[id="nextColumns"]').removeAttr('disabled');
  $('input[id="previousColumns"]').removeAttr('disabled');
  // show the label columns
  $("table.detailTable#scrollTable th:nth-child(n+"+(columnOffsetHeader)+")").show();
  // hide te columns between the label collumns and the startIndex
  $("table.detailTable#scrollTable th:nth-child(n+"+(columnOffsetHeader)+"):nth-child(-n+"+(columnOffsetHeader+startIndexHeader)+")").hide();
  // show the columns from column offset and showColumns
  $("table.detailTable#scrollTable th:nth-child(n+"+(columnOffsetHeader+startIndexHeader)+"):nth-child(-n+"+(columnOffsetHeader+startIndexHeader+showColumnsHeader)+")").show();
  // hide the columns at the end if there any
  $("table.detailTable#scrollTable th:nth-child(n+"+(columnOffsetHeader+startIndexHeader+showColumnsHeader)+"):nth-child(-n+"+(endIndexHeader)+")").hide();

  // scroll data columns
  $("table.detailTable#scrollTable td:nth-child(n+"+(columnOffsetData)+")").show();
  // hide te columns between the label collumns and the startIndex
  $("table.detailTable#scrollTable td:nth-child(n+"+(columnOffsetData)+"):nth-child(-n+"+(columnOffsetData+(startIndexData))+")").hide();
  // show the columns from column offset and showColumns
  $("table.detailTable#scrollTable td:nth-child(n+"+(columnOffsetData+(startIndexData))+"):nth-child(-n+"+(columnOffsetData+(startIndexData)+(showColumnsData))+")").show();
  // hide the columns at the end if there any
  $("table.detailTable#scrollTable td:nth-child(n+"+(columnOffsetData+(startIndexData)+(showColumnsData))+"):nth-child(-n+"+(endIndexData)+")").hide();


  if((startIndexHeader+columnOffsetHeader+showColumnsHeader)>=endIndexHeader){
    $('input[id="nextColumns"]').attr('disabled','disabled');
  }
  if((startIndexData+columnOffsetData+showColumnsData)>=endIndexData){
    $('input[id="nextColumns"]').attr('disabled','disabled');
  }
  if((startIndexHeader)<=0){
    $('input[id="previousColumns"]').attr('disabled','disabled');
  }
  if((startIndexData)<=0){
    $('input[id="previousColumns"]').attr('disabled','disabled');
  }

};

function initProductAutorisaties() {
  $('#radioButtons input:radio:disabled').parent().css({color: "#6E6E6E"});
  hideFilter();
  hideFilterColumns();
  hideDataTableCaption();
  hideTable();
  hideNoDataFound();
}

function klikWijzigen() {
  hideFilter();
  hideTable();
  if (rowsPresent('Wijzigen')) {
    filterRows('Wijzigen');
    showTable('Overzicht Natuurlijke Personen t.b.v. Wijzigen', 'Naam');
  } else {
    showNoDataFound();
  }
}

function klikOpheffen() {
  hideFilter();
  hideTable();
  if (rowsPresent('Opheffen')) {
    filterRows('Opheffen');
    showTable('Overzicht Natuurlijke Personen t.b.v. Opheffen', 'Naam');
  } else {
    showNoDataFound();
  }
}

function klikProductServices() {
  if (productServicesPresent()) {
    showFilter();
    hideTable();
    hideNoDataFound();
  } else {
    showNoDataFound();
  }
}

function klikInzien() {
  hideFilter();
  hideTable();
  if (rowsPresent('Inzien')) {
    filterRows('Inzien');
    showTable('Overzicht Natuurlijke Personen t.b.v. Inzien','Naam');
  } else {
    showNoDataFound();
  }
}

function changePerson(person) {
  if (person.value === '< Kies Persoon >') {
    hideDataTableCaption();
    hideTable();
  } else {
    resetFilter(false, true);
    if (nameRowsPresent(person.value)) {
      filterOnName(person.value);
      showTable('Autorisaties van ' + person.value + ' t.b.v. Productservices', 'Soort productservice');
    } else {
      showNoDataFound();
    }
  }
}

function changeService(service) {
  if (service.value === '') {
    hideDataTableCaption();
    hideTable();
  } else {
    resetFilter(true, false);
    if (serviceRowsPresent(service.value)) {
      filterOnService(service.value);
      showTable('Autorisaties t.b.v. Productservice \'' + $('#serviceKeuze option:selected').text() + '\'', 'Naam');
    } else {
      showNoDataFound();
    }
  }
}

function setFirstDataRowTitle(title) {
  $('#dataTable thead tr th:first').text(title);
}

function noDataFound() {
  showDataTableCaption('Er zijn geen product autorisaties gevonden.');
}

function showDataTableCaption(text) {
  $('#dataTableCaption').text(text);
  $('#dataTableCaption').show();
}

function hideDataTableCaption() {
  $('#dataTableCaption').text('');
  $('#dataTableCaption').hide();
}

function filterRows(code) {
  $('#dataTable tbody tr').each(function() {
    if (($(this).find('td:nth-child(5)').text() === 'P') &&
      ($(this).find('td:nth-child(4)').text() === code)) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });
}

function rowsPresent(code) {
  var rowsPresent = false;
  $('#dataTable tbody tr').each(function() {
    if (($(this).find('td:nth-child(5)').text() === 'P') &&
      ($(this).find('td:nth-child(4)').text() === code)) {
      rowsPresent = true;
    }
  });
  return rowsPresent;
}

function productServicesPresent() {
  var productServicesPresent = false;
  $('#dataTable tbody tr').each(function() {
    if ($(this).find('td:nth-child(4)').text() === 'Productservice') {
      productServicesPresent = true;
    }
  });
  return productServicesPresent;
}

function filterOnName(name) {
  $('#dataTable tbody tr').each(function() {
    if (($(this).find('td:nth-child(7)').text() === name) &&
      ($(this).find('td:nth-child(4)').text() === 'Productservice') &&
      ($(this).find('td:nth-child(5)').text() === 'S')) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });
}

function nameRowsPresent(name) {
  var rowsPresent = false;
  $('#dataTable tbody tr').each(function() {
    if (($(this).find('td:nth-child(7)').text() === name) &&
      ($(this).find('td:nth-child(4)').text() === 'Productservice') &&
      ($(this).find('td:nth-child(5)').text() === 'S')) {
      rowsPresent = true;
    }
  });
  return rowsPresent;
}

function filterOnService(service) {
  $('#dataTable tbody tr').each(function() {
    if (($(this).find('td:nth-child(4)').text() === 'Productservice') &&
      ($(this).find('td:nth-child(5)').text() === 'P') &&
      ($(this).find('td:nth-child(6)').text() === service)) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });
}

function serviceRowsPresent(service) {
  var rowsPresent = false;
  $('#dataTable tbody tr').each(function() {
    if (($(this).find('td:nth-child(4)').text() === 'Productservice') &&
      ($(this).find('td:nth-child(5)').text() === 'P') &&
      ($(this).find('td:nth-child(6)').text() === service)) {
      rowsPresent = true;
    }
  });
  return rowsPresent;
}

function resetFilter(personMenu, serviceMenu) {
  if (personMenu) {
    $('#persoonKeuze').val('< Kies Persoon >');
  }
  if (serviceMenu) {
    $('#serviceKeuze').val('< Kies Productservice >');
  }
}

function showFilter() {
  $("#personFilter").show();
  $("#filterSeparator").show();
  $("#serviceFilter").show();
}

function hideFilter() {
  $('#personFilter').hide();
  $("#filterSeparator").hide();
  $("#serviceFilter").hide();
  resetFilter(true, true);
}

function showNoDataFound() {
  $('#noData').show();
  hideTable();
}

function hideNoDataFound() {
  $('#noData').hide();
}

function showTable(tableCaption, firstColumnTitle) {
  showDataTableCaption(tableCaption);
  setFirstDataRowTitle(firstColumnTitle);
  hideNoDataFound();
  $('#dataTable').show();
}

function hideTable() {
  hideDataTableCaption();
  $('#dataTable').hide();
}

function showDataColumns() {
  $('table thead tr th').eq(1).show();
  $('table thead tr th').eq(2).show();
  $('table thead tr th').eq(3).show();
}

function hideFilterColumns() {
  for (var ix = 3; ix < 8 ; $('#dataTable thead tr th').eq(ix++).hide()){
    $('#dataTable tbody tr').each(function() {
      $(this).find('td:nth-child(4)').hide();
      $(this).find('td:nth-child(5)').hide();
      $(this).find('td:nth-child(6)').hide();
      $(this).find('td:nth-child(7)').hide();
    });
  }
}

function returnResponseText(request){
  return request.responseText
}
